(() => {
  function setupDrawerAnimation() {
    document.querySelectorAll('.rp-drawer').forEach((drawer) => {
      if (drawer.dataset.rpDrawerBound === 'true') return;

      const panel = drawer.querySelector('.rp-drawer__panel');
      const summary = drawer.querySelector('.rp-drawer__summary');
      if (!panel || !summary) return;

      drawer.dataset.rpDrawerBound = 'true';

      function openPanel() {
        const start = panel.offsetHeight;
        panel.style.height = `${start}px`;
        panel.offsetHeight;
        panel.style.height = `${panel.scrollHeight}px`;
        panel.addEventListener('transitionend', () => {
          panel.style.height = 'auto';
        }, { once: true });
        drawer.classList.add('highlight');
        window.setTimeout(() => drawer.classList.remove('highlight'), 600);
      }

      function closePanel() {
        panel.style.height = `${panel.scrollHeight}px`;
        panel.offsetHeight;
        panel.style.height = '0';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (drawer.hasAttribute('open')) {
          closePanel();
          window.setTimeout(() => drawer.removeAttribute('open'), 300);
        } else {
          drawer.setAttribute('open', '');
          window.requestAnimationFrame(openPanel);
        }
      });

      if (drawer.hasAttribute('open')) panel.style.height = 'auto';
    });
  }

  function setupBadgePointer() {
    document.querySelectorAll('.rp-badge').forEach((badge) => {
      if (badge.dataset.rpPointerBound === 'true') return;
      badge.dataset.rpPointerBound = 'true';
      badge.addEventListener('pointermove', (event) => {
        const rect = badge.getBoundingClientRect();
        badge.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        badge.style.setProperty('--my', `${event.clientY - rect.top}px`);
      });
    });
  }

  function hideDuplicateWishlist() {
    const appWishlist = document.querySelector('[class*="xb-wishlist" i], [id*="xb-wishlist" i], [data-xb-wishlist], [class*="button_wishlist" i]');
    if (!appWishlist) return;

    document.querySelectorAll('.rp-wishlist-pdp-icon').forEach((button) => {
      button.hidden = true;
      button.setAttribute('aria-hidden', 'true');
    });
  }

  function init() {
    setupDrawerAnimation();
    hideDuplicateWishlist();
    setupBadgePointer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
